import actions from '../actions';
import getters from '../getters';
import mutations from '../mutations';

export default {
  state: {
    activeTab: null,
  },
  actions,
  getters,
  mutations,
};
